import * as Yup from 'yup';
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Form as FForm, Field, Formik, ErrorMessage } from "formik";
import userService from '../../service/UserService'
import { AppContext } from '../../util/AppContext';

export const Login = () => {
  const navigate = useNavigate();
  const { login } = useContext(AppContext)

  const [ viewPassword, setViewPassword ]= useState(true);
  const initialValues = { email: '', password: '', role : 'ADMIN' };
  const requestFormSchema = Yup.object().shape({
    email: Yup.string().email('Enter valid email.').required("Email is required.").trim(),
    password: Yup.string().required("Password is required.").trim(),
    role : Yup.string()
  });

  const handleFormSubmit = async (data) => {
    const response = await userService.login(data);
    if(response.status==200) {
      login(response.data.data.token, response.data.data.user);
      navigate("/home")
    }
  };

  return (
    <>
      <div className="login-outer-area">
        <div className="login-area">
          <Container fluid>
            <Row className='justify-content-center login-heading'>
              {/* <Col md={6}>
                 <h1 className='text-center'>WELCOME TO THE ADMIN PANEL</h1>
                 <h5 className='text-center'>Power Your Marketplace From Here.</h5>
              </Col> */}
            </Row>
            <Row className="justify-content-center">
              <Col xl={5} md={6} >
                <div className="login-content-area">
                  <img src={ require("../../assets/images/V2A-logo.png")} />
                  <h2>Admin Login </h2>
                  <Formik initialValues={initialValues} validationSchema={requestFormSchema} onSubmit={handleFormSubmit}>
                    {() => (
                      <FForm>
                        <div className='login-fiels-outer'>
                          <div className='login-fields-inner'>
                            <Form.Group>
                              <Field type="email" placeholder="Email" id="email" name="email" />
                            </Form.Group>
                            {/* <img src={ require("../../assets/images/emaili-icon.svg").default} /> */}
                          </div>
                          <ErrorMessage name="email" component="div" className="text-danger" />
                        </div>


                        <div className='login-fiels-outer'>
                          <div className='login-fields-inner'>
                            <Form.Group>
                              <Field type={ viewPassword ? 'password' : 'text' } placeholder="Password" id="password" name="password" />
                            </Form.Group>
                            { viewPassword ?
                              <img src={ require("../../assets/images/eye-icon.svg").default}  alt='img' onClick={ () =>  setViewPassword(!viewPassword) }/> :
                              <img src={ require("../../assets/images/eye-slash.svg").default}  alt='img' onClick={ () =>  setViewPassword(!viewPassword) }/>
                            }
                          </div>
                          <ErrorMessage name="password" component="div" className="text-danger" />
                        </div>

                        <Button className="w-50" variant="primary" type="submit">
                          Login
                        </Button>
                      </FForm>
                    )}
                  </Formik>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};
